import { useState } from 'react';
import { Optional } from '@/generic/functional';
import { inject } from '@/rules-management/injections.ts';
import { RULES_REPOSITORY } from '@/rules-management/RulesManagementKeys.ts';
import type { DraftRuleEdit, DraftRuleId } from '@/rules-management/domain/DraftRule.ts';

const toError = (error: unknown): Error =>
  error instanceof Error ? error : new Error(String(error));

export const useDraftRulesEdition = ({
  reloadDrafts,
}: {
  reloadDrafts: (page: number) => Promise<void>;
}) => {
  const [editFailure, setEditFailure] = useState<Optional<Error>>(Optional.empty());

  const handleSave = (id: DraftRuleId, edit: DraftRuleEdit, page: number): Promise<boolean> => {
    setEditFailure(Optional.empty());
    return inject(RULES_REPOSITORY)
      .update(id, edit)
      .then(() => reloadDrafts(page))
      .then(() => true)
      .catch((error) => {
        setEditFailure(Optional.of(toError(error)));
        return false;
      });
  };

  const reset = () => setEditFailure(Optional.empty());

  return { editFailure, handleSave, reset };
};
